import React from 'react'

function InvestorCRM() {
  return (
    <div>InvestorCRM</div>
  )
}

export default InvestorCRM